import * as React from "react";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import { cn } from "../../lib/utils";

const ScrollArea = React.forwardRef(
  ({ className, style, children, ...props }, ref) => (
    <ScrollAreaPrimitive.Root
      ref={ref}
      className={cn("tw-relative tw-overflow-hidden", className)}
      style={{ position: "relative", overflow: "hidden", height: "100%", minHeight: 0, ...style }}
      {...props}
    >
      <ScrollAreaPrimitive.Viewport
        className="tw-h-full tw-w-full tw-rounded-[inherit] [&>div]:!tw-block"
        style={{ height: "100%", width: "100%" }}
      >
        {children}
      </ScrollAreaPrimitive.Viewport>
      <ScrollBar />
      <ScrollAreaPrimitive.Corner />
    </ScrollAreaPrimitive.Root>
  )
);
ScrollArea.displayName = "ScrollArea";

const ScrollBar = React.forwardRef(
  ({ className, orientation = "vertical", ...props }, ref) => (
    <ScrollAreaPrimitive.ScrollAreaScrollbar
      ref={ref}
      orientation={orientation}
      className={cn(
        "tw-flex tw-touch-none tw-select-none tw-transition-colors",
        orientation === "vertical" &&
          "tw-h-full tw-w-1.5 tw-border-l tw-border-l-transparent tw-p-px",
        orientation === "horizontal" &&
          "tw-h-1.5 tw-flex-col tw-border-t tw-border-t-transparent tw-p-px",
        className
      )}
      {...props}
    >
      <ScrollAreaPrimitive.ScrollAreaThumb
        className="tw-relative tw-flex-1 tw-rounded-full"
        style={{ background: "rgba(255,255,255,0.14)" }}
        onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.24)")}
        onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.14)")}
      />
    </ScrollAreaPrimitive.ScrollAreaScrollbar>
  )
);
ScrollBar.displayName = "ScrollBar";

export { ScrollArea, ScrollBar };
